export * from './src/Heading';
